import { render, staticRenderFns } from "./PascalLaunchFaqs.vue?vue&type=template&id=4d118eeb&scoped=true&"
import script from "./PascalLaunchFaqs.vue?vue&type=script&lang=js&"
export * from "./PascalLaunchFaqs.vue?vue&type=script&lang=js&"
import style0 from "./PascalLaunchFaqs.vue?vue&type=style&index=0&id=4d118eeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d118eeb",
  null
  
)

export default component.exports